module.exports = __webpack_public_path__ + "static/media/image-placeholder.7e2aa71c.svg";